import { supabase } from "@/integrations/supabase/client";

interface DetectedItem {
  name: string;
  quantity: number;
  room: string;
  notes?: string;
}

export async function analyzeBoxContents(imageData: string): Promise<DetectedItem[]> {
  const TIMEOUT_MS = 30000; // 30 seconds
  
  const timeoutPromise = new Promise<never>((_, reject) => {
    setTimeout(() => reject(new Error('Analysis timed out after 30 seconds')), TIMEOUT_MS);
  });
  
  const analysisPromise = supabase.functions.invoke('analyze-box-image', {
    body: { imageData }
  });
  
  try {
    const { data, error } = await Promise.race([analysisPromise, timeoutPromise]) as any;
    
    if (error) {
      console.error('Edge function error:', error);
      throw new Error(error.message || 'Failed to analyze image. Please try again.');
    }
    
    if (!data || !data.items) {
      throw new Error('No items detected in the image.');
    }
    
    return data.items;
  } catch (error) {
    if (error instanceof Error && error.message.includes('timed out')) {
      throw new Error('Image analysis is taking too long. Please try with a clearer photo or skip AI analysis.');
    }
    throw error;
  }
}
